import { useHandoffSettingsQuery, useSetLiveAgentsEnabledMutation } from '../../hooks/useHandoff';
import { useAuth } from '../../utils/authcontextt';

export function LiveAgentsToggle() {
  const { user } = useAuth();
  const { data } = useHandoffSettingsQuery();
  const setEnabled = useSetLiveAgentsEnabledMutation();

  if (user?.role !== 'admin') return null;

  const isOn = data?.liveAgentsEnabled ?? true;

  return (
    <div
      className="flex items-center gap-2"
      title="Av = alla nya handoffs går till mail istället för live-agent"
    >
      <button
        type="button"
        role="switch"
        aria-checked={isOn}
        aria-label="Live-agenter på/av"
        disabled={setEnabled.isPending}
        onClick={() => setEnabled.mutate(!isOn)}
        className={[
          'relative inline-flex h-6 w-11 items-center rounded-full transition',
          isOn ? 'bg-green-500' : 'bg-gray-300',
          setEnabled.isPending ? 'opacity-60' : '',
        ].join(' ')}
      >
        <span
          className={[
            'inline-block h-5 w-5 transform rounded-full bg-white shadow transition',
            isOn ? 'translate-x-5' : 'translate-x-1',
          ].join(' ')}
        />
      </button>
      <span className="text-xs font-medium text-gray-600">Live-agenter</span>
    </div>
  );
}
